var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { getCarrierListSuccess, getCarrierListFailure, GET_CARRIER_LIST_REQUEST } from "../../actions";
import APIIN from "@/utils/APIIN";
const onFetchCarrierList = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`/rms/admin/rate/zone/carrier/list?tenantId=${action.payload.tenantId}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchCarrierListWorker(action) {
    try {
        const data = yield call(onFetchCarrierList, action);
        yield put(getCarrierListSuccess(data));
    }
    catch (error) {
        yield put(getCarrierListFailure(error));
    }
}
export function* watchCarrierListData() {
    yield takeLatest(GET_CARRIER_LIST_REQUEST, fetchCarrierListWorker);
}
